/* eslint-disable no-restricted-syntax */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import { toastError, toastSuccess } from '../../../../redux/actions/alertActions';
import coursePlanServices from '../../../../redux/services/coursePlanServices';
import groupServices from '../../../../redux/services/groupServices';
import objectiveServices from '../../../../redux/services/objectiveServices';
// import { toastSuccess } from '../../../../redux/actions/alertActions';

const useUpdateCoursePlan = () => {
  const updateCoursePlan = (courseplanId, contentIds, vocPro, vocInterests, vocWork) => {
    const vocs = {
      vocPro: [],
      vocInterests: [],
      vocWork: [],
    };

    for (const item in vocPro) {
      if (vocPro[item]) {
        vocs.vocPro.push(item);
      }
    }
    for (const item in vocInterests) {
      if (vocInterests[item]) {
        vocs.vocInterests.push(item);
      }
    }
    for (const item in vocWork) {
      if (vocWork[item]) {
        vocs.vocWork.push(item);
      }
    }
    const getGroup = async () => {
      const group = await groupServices.getGroupByCoursePlan(courseplanId);
      return group;
    };

    const body = {
      formationContent: contentIds,
      vocPro: vocs.vocPro,
      vocInterests: vocs.vocInterests,
      vocWork: vocs.vocWork,
    };

    const setCourseObjectives = (level, needs) => {
      let sentence = '';
      if (level === 2) {
        sentence = `Développer les compétences linguistiques requises et le vocabulaire pour être capable de communiquer lors d'échanges professionnels dans le(s) domaine(s) : ${needs}.`;
      }
      if (level === 3) {
        sentence = `Développer les compétences linguistiques requises et approfondir le vocabulaire afin de communiquer clairement lors d'échanges professionnels dans le(s) domaine(s) : ${needs}.`;
      }
      if (level === 4) {
        sentence = `Approfondir les compétences linguistiques requises et le vocabulaire pour communiquer clairement et sans difficultés lors d'échanges professionnels dans le(s) domaine(s) : ${needs}.`;
      }
      return sentence;
    };

    const updateGroupWithNeeds = async () => {
      const translations = {
        logistics: 'logistique',
        sales: 'ventes',
        marketing: 'marketing',
        finance: 'finance',
        legal: 'juridique',
        engineering: 'ingénierie',
        production: 'production',
        quality: 'qualité',
        it: 'informatique',
        hr: 'RH',
      };

      const translatedVocPro = Object.fromEntries(
        Object.entries(vocPro).map(([key, value]) => [
          translations[key] || key,
          value,
        ]),
      );

      const group = await getGroup();
      if (group.objectives && group.objectives.length > 0 && group.level > 1) {
        const needs = Object.keys(translatedVocPro)
          .filter((key) => translations[translatedVocPro[key]] || translatedVocPro[key])
          .join(', ');
        const newSentence = setCourseObjectives(group.level, needs);
        const targetObjectives = group.objectives.filter((obj) => obj.name.includes('dans le(s) domaine(s)')
          || obj.name.includes('vocabulaire dans le domaine'));
        for (const obj of targetObjectives) {
          const updatedObj = { ...obj, name: newSentence };
          objectiveServices.updateObjectives(obj._id, updatedObj);
        }
      }
    };

    coursePlanServices.updateCoursePlan(
      courseplanId,
      body,
    )
      .then((res) => {
        updateGroupWithNeeds();
        if (res !== undefined && res !== null) {
          toastSuccess('Content updated successfully');
          return;
        }
        toastError('Content update failed');
      });
  };
  return {
    updateCoursePlan,
  };
};

export default useUpdateCoursePlan;
